<template>
  <v-card-title class="py-4 px-6">
    <div class="d-flex align-center">
      <h6 class="text-h6 mr-4">
        {{
          isPublished ? formatDate(publishedAt) : 'Current Revision'
        }}
      </h6>
      <template v-if="isPublished">
        <researcher-avatar
          :researcher="publishedBy"
          small
          class="ml-2"
        />
        <span class="ml-2 grey--text subtitle-2">
          <strong class="black--text">
            {{ publishedBy.firstName() }}
          </strong>
          published
          {{ timeAgo(publishedAt) }}
        </span>
      </template>
    </div>
  </v-card-title>
</template>

<script>
import ResearcherAvatar from '@/components/Common/ResearcherAvatar';
import { Revision } from '@/models';
import { formatDistanceToNow, format } from 'date-fns';

export default {
  name: 'RevisionCardHeader',
  components: {
    ResearcherAvatar,
  },
  props: {
    revision: {
      type: Revision,
      required: true,
    },
  },
  computed: {
    isPublished() {
      return this.revision.isPublished;
    },
    publishedAt() {
      return this.revision.publishedAt;
    },
    publishedBy() {
      return this.revision.publishedBy;
    },
  },
  methods: {
    formatDate(date) {
      return format(new Date(date), 'dd MMM yyyy');
    },
    timeAgo(date) {
      return formatDistanceToNow(new Date(date), { addSuffix: true });
    },
  },
};
</script>
